export const AUTH_TYPE = {
  IS_LOADING: "IS_LOADING",
  NAME: "NAME",
  LOGIN_FAILED: "LOGIN_FAILED",
  LOGIN_SUCCESS: "LOGIN_SUCCESS",
  ROLE: "ROLE",
  ID: "ID",
  EMAIL: "EMAIL",
  LOGOUT: "AUTH_LOGOUT",
};
